import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'SelfServeBuilder';

export default class RecipientManagerFooter extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <div className="footer-container">
          <IconButton
            text="Back to Organize Sections"
            imageSrc="/images/self-serve-builder/side-panel/back-arrow-icon-2x.png"
            containerClass="left"
            onClick={this.props.clickBackToOrganizeSections}
            imageAlt="Back"
            imageWidth={7}
          />
        </div>
      </React.Fragment>
    );
  }
}

RecipientManagerFooter.propTypes = {
  clickBackToOrganizeSections: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/RecipientManagerFooter.jsx